import { AppWidgetState, Dashboard, isInvestorQueryType } from '@ddv/models';
import { WidgetOnBoard } from '@ddv/widget-on-boards';

import { DashboardWithoutWidgets } from './dashboard-without-widgets';

export class DashboardDetails extends DashboardWithoutWidgets implements Dashboard {
    widgets: AppWidgetState[];
    widgetsOnBoard: WidgetOnBoard[];

    constructor(init: Partial<Dashboard>, widgetsOnBoard: WidgetOnBoard[]) {
        super(init);

        this.widgetsOnBoard = widgetsOnBoard;
        this.widgets = this.widgetsOnBoard.map((wob) => new AppWidgetState(wob.widget));
    }

    isSingleNamedQuery(): boolean {
        return this.widgetsOnBoard.reduce((distinctNamedQueryIds: string[], wob) => {
            const namedQueryId = wob.widget?.namedQueryId;
            if (namedQueryId && !distinctNamedQueryIds.includes(namedQueryId)) {
                distinctNamedQueryIds.push(namedQueryId);
            }

            return distinctNamedQueryIds;
        }, []).length === 1;
    }

    isInvestorOnly(): boolean {
        return !!this.widgets.length && this.areAllWidgetsInvestor();
    }

    getNamedQueryIds(): (string | undefined)[] {
        return this.widgets?.map((w) => w.namedQueryId) ?? [];
    }

    isAdhoc(): boolean {
        return this.widgets.some((w) => w.namedQuery?.isAdhoc());
    }

    private areAllWidgetsInvestor(): boolean {
        return this.widgets.every((w) => isInvestorQueryType(w.namedQuery?.normalizeQueryTypeName()));
    }
}
